import React, { FC } from 'react';
import Styles from './NewMessagesDivider.module.scss';

/** Discord-style "NEW" bar between read and unread messages. */
const NewMessagesDivider: FC = () => (
  <div
    className={Styles.divider}
    data-new-messages-divider
    aria-label="New messages"
  >
    <span className={Styles.badge}>New</span>
  </div>
);

export default NewMessagesDivider;
